// eslint-disable-next-line import/no-default-export -- deprecated usage
export { default } from "./FormField";
export type { FormFieldProps } from "./FormField";
export type { FieldAlignment, FieldOrientation } from "./types";
